import { ControllerRenderProps, FieldValues } from 'react-hook-form'

import { TextField } from 'elements/TextField'

interface TextFieldOfflineProps {
  label: string
  field: ControllerRenderProps<FieldValues, string>
}

export default function TextFieldOffline({
  label,
  field,
}: TextFieldOfflineProps): JSX.Element | null {
  const { name, value } = field

  return (
    <TextField
      label={label}
      name={`${name}_offline`}
      defaultValue={value.formattedAddress}
      validations={{}}
    />
  )
}
